import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideAuth0 } from '@auth0/auth0-angular';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import {
  AUTH_CONFIG,
  AUDIT_SOURCE,
  authInterceptor,
  auditSourceInterceptor,
  providePortalPermissionsBootstrapRefresh,
  provideFeatureFlags,
  providePortalTitle
} from '@lr/core';
import { API_BASE_URL, ENROLLMENT_BASE_URL } from '@lr/data-access';
import { environment } from './environments/environment';
import { hrAuthErrorInterceptor } from './app/interceptors/hr-auth-error.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    providePortalTitle('Client Portal'),
    provideHttpClient(
      withInterceptors([hrAuthErrorInterceptor, auditSourceInterceptor, authInterceptor])
    ),
    provideAnimations(),
    provideEnvironmentNgxMask(),
    { provide: AUTH_CONFIG, useValue: environment.auth },
    { provide: AUDIT_SOURCE, useValue: 'Client Portal' },
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: ENROLLMENT_BASE_URL, useValue: environment.enrollmentBaseUrl },
    providePortalPermissionsBootstrapRefresh(),
    provideFeatureFlags(environment.auth.portalKey),
    provideAuth0({
      domain: environment.auth.domain,
      clientId: environment.auth.clientId,
      authorizationParams: {
        redirect_uri: environment.auth.redirectUri,
        audience: environment.auth.audience,
        scope: 'openid profile email offline_access',
        ...(environment.auth.connection && { connection: environment.auth.connection })
      },
      cacheLocation: environment.auth.cacheLocation,
      useRefreshTokens: environment.auth.useRefreshTokens,
      useRefreshTokensFallback: true,
      skipRedirectCallback: true, // Let Auth0 handle callback
      httpInterceptor: {
        allowedList: [
          '/api/*'
        ]
      }
    })
  ]
}).catch(err => console.error(err));


